import { ButtonStyles } from '../schema/enum/button-styles';

export function getButtonClass(styleOverride?: string): string {
    let btnStyleClass: string = 'theme-default';
    if (styleOverride) {
        switch (styleOverride) {
            case ButtonStyles.DEFAULT:
                btnStyleClass = 'default';
                break;
            case ButtonStyles.SECONDARY:
                btnStyleClass = 'secondary';
                break;
            case ButtonStyles.BORDERED:
                btnStyleClass = 'bordered';
                break;
        }
    }

    return `btn ${btnStyleClass}`;
}
